import React from 'react';
import { useIntl } from 'react-intl';
import { IOption } from '../../../../models/product-detail';
import { NO_CHARGER } from '../../../common/constants';

interface OptionsRadioProps {
    options: IOption[];
    label?: string;
    value: number | string | undefined;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    name: string;
    inline?: boolean;
    materialHHSMessage?: boolean;
}

const OptionsRadio = ({
    options,
    value,
    onChange,
    name,
    inline,
    label,
    materialHHSMessage,
}: OptionsRadioProps) => {
    const intl = useIntl();
    return (
        <>
            <div>
                {label && (
                    <p>
                        {intl.formatMessage({
                            id: label.replace(' ', '_'),
                            defaultMessage: label,
                        })}
                    </p>
                )}
            </div>
            {options.map((x) => {
                return (
                    <div className="radio" key={x.name}>
                        <label>
                            <input
                                type="radio"
                                value={x.id}
                                id={x.partNumber}
                                name={name}
                                checked={
                                    x.id === value ||
                                    x.partNumber === value ||
                                    (x.name === NO_CHARGER && !value)
                                }
                                onChange={onChange}
                                style={{
                                    display: inline ? 'inline-block' : 'block',
                                }}
                            />
                            <span>{x.name}</span>
                        </label>
                    </div>
                );
            })}
            {materialHHSMessage && (
                <div className="row" style={{ marginLeft: '3px' }}>
                    <i>
                        {intl.formatMessage({
                            id: 'In_the_event_of_narrow_canals',
                            defaultMessage:
                                'In the event of narrow canals, tube will be glued if we cannot thru-tube.',
                        })}
                    </i>
                </div>
            )}
        </>
    );
};

export default OptionsRadio;
